import { useInNoteSetupContext } from 'shared/features/note-setup';
import { useNoteForPathContext } from 'pages/Note/contexts';
import { useUnscheduledNoteForPathContext } from 'pages/UnscheduledInteraction/contexts';
export var useAnyContextNoteId = function () {
    var inNoteSetupContext = useInNoteSetupContext();
    var noteId = '';
    if (inNoteSetupContext) {
        var scheduledNoteId = useNoteForPathContext().noteId;
        noteId = scheduledNoteId !== null && scheduledNoteId !== void 0 ? scheduledNoteId : '';
    }
    else {
        // otherwise, in an unscheduled interaction
        var unscheduledNoteId = useUnscheduledNoteForPathContext().noteId;
        noteId = unscheduledNoteId !== null && unscheduledNoteId !== void 0 ? unscheduledNoteId : '';
    }
    return noteId;
};
